export var ProductAttrValueType;
(function (ProductAttrValueType) {
    ProductAttrValueType["STRING"] = "string";
    ProductAttrValueType["INT"] = "integer";
    ProductAttrValueType["BOOL"] = "boolean";
    ProductAttrValueType["FLOAT"] = "float";
})(ProductAttrValueType || (ProductAttrValueType = {}));
